import axios from "@/api/axiosInstance";
import { FetchAttemptForReviewResponse } from "./types";
import type { CoachAttemptDetail } from "../../types/diagnostic";

/** One attempt with its instrument, answers and recomputed placement. */
export const fetchAttemptForReview = async (
  attemptId: number,
  signal?: AbortSignal,
): Promise<CoachAttemptDetail> => {
  const response = await axios.get<FetchAttemptForReviewResponse>(
    `/api/private/attempts/${attemptId}/review`,
    { signal },
  );
  return response.data.data;
};
